const Form002SC = {
    stepName: {
        ImportantNotes: "重要提示",
        Selection: "选择表格",
        PartA: "「功绩荣誉奖励计划」提名表",
        PartB: "校长服务记录表",
        Confirmation: "确认",
    },
    errorMsg: {
        yearThree: "同一年度最多允许填写三个活动",
        conflict: "服务日期不能重叠",
        year: "获奖年份不得晚于{{year}}年",
        natureWork: "此字段仅允许输入1或者2",
        position: "字数不多于100字",
        serviceYearTotal: "服务年数总计不能低于{{year}}年",
        avoidDuplicate: "请不要与【II. 提名获奖项目】中的选择重复",
        notSame: "请不要选择相同的年份",
    },
    importantNotes: [
        "教育局会利用本表格所载的个人资料，作处理有关功绩荣誉奖励计划的相关事宜的用途。",
        "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果会受影响。",
        "本表格所收集的个人资料，或会向其他获授权的政府决策局／部门／机构披露作上述用途。",
        "根据《个人资料（私隐）条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        "如欲查询有关本表格所收集的个人资料，包括要求查阅及改正资料事宜，需透过电邮（<a href='mailto:info_cyc@edb.gov.hk'>info_cyc@edb.gov.hk</a>）向教育局延伸支援计划组提出。",
        "获提名参加者有权根据《个人资料（私隐）条例》（香港特别行政区法例第 <b>486</b> 章）第 <b>18</b> 和 <b>22</b> 条，以及附表 <b>1</b> 第 <b>6</b> 项原则规定，查阅和更正所提供的个人资料。如对参加交流团所收集的个人资料有任何查询，包括查阅及更正资料，请联络香港湾仔皇后大道东 <b>213</b> 号胡忠大厦 <b>11</b> 楼 <b>1141</b> 室教育局公益少年团办事处（电话：<b>2892 6660</b>）。",
    ],
    label: {
        notes: "个人资料收集声明",
        PersonalInfo: "个人资料",
        Nominate: "提名获奖项目",
        ServiceRecord: "服务记录",
        GainedRewards: "曾获颁授之公益少年团功绩荣誉奖（如有）",
        OtherReason: "其他有关值得提名的原因（如有）",
        PrincipleInfo: "校长资料",
        GainedRewardsA: "曾获颁授之公益少年团功绩荣誉奖",
        positionOption: {
            teacher: "教师",
            manager: "主任",
            vicePrincipal: "副校长",
            socialWorker: "社工",
            others: "其他",
        },
        positions: {
            chairman: "主席",
            viceChairman: "副主席",
            secretary: "秘书",
            cashier: "司库",
            committee: "委员",
        },
        rewardOption: {
            appreciationOneYear: "感谢状（已服务一年）",
            appreciationTwoYear: "感谢状（已服务二年）",
            appreciationThreeYear: "嘉许状（已服务三至四年）",
            specialOneYear: "嘉许状（只服务一丶两年但获特殊破格提名）",
            appreciationFiveYear: "忠诚服务奖（已服务不少于五年）",
            appreciationSevenYear: "良好服务奖（已服务不少于七年）",
            appreciationTenYear: "优异服务奖（已服务不少于十年）",
            appreciationFifteenYear: "铜章（已服务不少于十五年）",
            appreciationTwentyYear: "银章（已服务不少于二十年）",
            noAwards: "获提名人未曾领取任何奖项",
        },
        rewardAOption: {
            appreciationFiveYearA: "忠诚服务奖（已服务不少于五年）",
            appreciationSevenYearA: "良好服务奖（已服务不少于七年）",
            appreciationTenYearA: "优异服务奖（已服务不少于十年）",
            appreciationThirteenYearA: "铜章（已服务不少于十三年）",
            appreciationSixteenYearA: "银章（已服务不少于十六年）",
            appreciationYearA: "金章（由本团会长审核及颁赠）",
            noAppreciation: "本人未曾领取任何奖项",
        },
        rewardYearOption: {
            appreciationOneYear: 1,
            appreciationTwoYear: 2,
            appreciationThreeYear: 3,
            specialOneYear: 1,
            appreciationFiveYear: 5,
            appreciationSevenYear: 7,
            appreciationTenYear: 10,
            appreciationFifteenYear: 15,
            appreciationTwentyYear: 20,
        },
        rewardAYearOption: {
            appreciationFiveYearA: 5,
            appreciationSevenYearA: 7,
            appreciationTenYearA: 10,
            appreciationThirteenYearA: 13,
            appreciationSixteenYearA: 16,
        },
        selectionOption: {
            partA: "公益少年团「功绩荣誉奖励计划」提名表",
            partB: "公益少年团「功绩荣誉奖励计划」校长服务记录表",
        },
        titleOption: {
            Mr: "先生",
            Miss: "小姐",
            Ms: "女士",
            Dr: "博士",
        },
        titleOptionE: {
            Mr: "Mr",
            Miss: "Miss",
            Ms: "Ms",
            Dr: "Dr.",
        },
        nomineeTitle: "获提名人称谓",
        nomineeName: "获提名人中文姓名",
        principleTitle: "校长称谓",
        principleName: "校长姓名",
        position: "职衔",
        specify: "请注明职衔",
        schoolName: "学校",
        schoolAddress: "学校地址",
        schoolTel: "学校电话",
        schoolFax: "传真号码",
        district: "所属分区",
        startServiceDate: "开始服务日期",
        endServiceDate: "结束服务日期",
        project: "校本／区本／中央项目",
        projectPosition: "具体工作岗位、贡献（如负责教师、学员训练、项目统筹）",
        startProjectDate: "项目开始日期",
        endProjectDate: "项目结束日期",
        rewardYear: "获奖年份",
        serviceYear: "甲. 服务年数",
        excellentService: "乙. 服务期间，表现优异的项目",
        nominate: "提名获奖项目",
        activity: "校本／区本／中央项目",
        activityPosition:
            "具体工作岗位、贡献（如负责教师、学员训练、项目统筹）",
        otherReason: "其他有关值得提名的原因（如有）",
        proofDoc: "奖项证明文件",
        proofDocTitle: "奖项证明文件",
        proofDocText: "奖项证明文件只接受：.pdf，.png，.jpg，.doc",
        nominateTooltip: "获提名人的服务记录请详列于 III.服务记录",
        serviceYearTooltip: "以学年计算，不包括服务中断时间",
        total: "共",
        year: "年",
        month: "个月",
        annex: "（提名细则，请参阅【附件一】）",
        title: "﹝服务年资以截至2020／21学年完结为止计算，例：如于2020年9月开始服务，即可提名服务一年感谢状﹞",
        nomineeTitleE: "获提名人英文称谓",
        nomineeNameE: "获提名人英文姓名",
        autoGenerate: "自动填写",
        title1: "：（以下各项如有需要可另纸书写或夹附数据）",
        title2: "﹝服务年资以截至2020／21学年完结为止计算，例：如于2020年9月开始服务，可填2020／9至2021／8共1年0月﹞",
        statement: "个人资料收集声明",
        yearA: "截至",
        year1: "年度为止（以学年计算），本人担任本团会员学校导师及校长合共_______年，当中不包括中断年份。",
        countYear: "﹝例：如于2020年9月开始担任，即填1年﹞",
        title2A:
            "最近三年担任本团分区执行委员会职务（在适当位置加「√」）（如有）",
        title3: "最近三年统筹区本活动记录（如有）",
        annual: "年度",
        activityName: "活动名称",
        jobCategory: "工作性质",
        jobCategoryOption: {
            1: "总负责人",
            2: "协助",
        },
        post: "职务",
        totalA: "合共",
        principleTitleE: "校长英文称谓",
        principleNameE: "校长英文姓名",
    },
    dataList: [
        {
            text: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
        },
        {
            text: "办理与聘用有关的事宜；",
        },
        {
            text: "处理发放薪金津贴，以及计算公积金的供款和赠款；",
        },
        {
            text: "进行核数工作；",
        },
        {
            text: "进行研究及统计资料，以便规划教育服务；",
        },
        {
            text: "处理有关教育专业人员发展的事宜；",
        },
        {
            text: "执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",
        },
        {
            text: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        },
        {
            text: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        },
        {
            text: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        },
        {
            text: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
        },
    ],
    symbolList: [
        { text: "(a)" },
        { text: "(b)" },
        { text: "(c)" },
        { text: "(d)" },
        { text: "(e)" },
        { text: "(f)" },
    ],
    tooltipList: {
        tableTooltip: {
            tooltip001: "校本/区本/中央项目",
            tooltip002: "日期",
            tooltip003: "具体工作岗位、贡献（如负责教师、学员训练、项目统筹）",
            tooltip004:
                "例：策划本校团员历年的社区服务活动项目包括：________________（校本）",
            tooltip005: "7-12/4/{{year}}",
            tooltip006: "公益少年团导师，积极策划、检讨、发展本校团务工作",
            tooltip007: "例：公益少年团某区周年颁奖礼（区本）",
            tooltip008: "15/9/{{year}}",
            tooltip009: "计划统筹，节目策划及人手调动",
            tooltip010: "例：公益少年团杰出团员海外交流团（中央）",
            tooltip011: "7/{{year}}",
            tooltip012: "领队教师、参与团员出发前训练",
        },
        otherTooltip: {
            tooltip013: "示例 1：",
            tooltip014:
                "公益少年团xx区周年颁奖礼（区本）担任计划统筹，节目策划及人手调动，使典礼成功完成，获区委一致好评。",
            tooltip015: "示例 2：",
            tooltip016:
                "担任公益少年团导师（校本），期间使团员增长率提高两倍，至xxx人，组织及训练团员策划社区服务x次，使学生领导及组织能力提升，信心得以建立。",
        },
    },
    districtOption: {
        CW: "中西区",
        HKE: "东区",
        SOU: "南区",
        I: "离岛区",
        WCH: "湾仔区",
        KC: "九龙城区",
        KT: "观塘区",
        SSP: "深水埗区",
        WTS: "黄大仙区",
        YTM: "油尖旺区",
        KWT: "葵青区",
        TW: "荃湾区",
        YL: "元朗区",
        TM: "屯门区",
        N: "北区",
        SK: "西贡区",
        ST: "沙田区",
        TP: "大埔区",
    },
};
export default Form002SC;
